import { TransactionType } from '../transactions.js';
export var TonChainID;
(function (TonChainID) {
    TonChainID["MAINNET"] = "-239";
    TonChainID["TESTNET"] = "-3";
})(TonChainID || (TonChainID = {}));
export var isTonTransaction = function (transaction) { return transaction.type === TransactionType.TON; };
//# sourceMappingURL=ton.js.map